import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SpinnerComponent } from '../component/spinner/spinner.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NumberswitcherPipe } from '../../../util/pipes/numberswitcher.pipe';
import { SwitcherDashBracesPipe } from '../../../util/pipes/switcherDashBraces.pipe';
import { DeleteButtonComponent } from '../component/icons-deprecated/delete-button/delete-button.component';
import { CopyButtonComponent } from '../component/icons-deprecated/copy-button/copy-button.component';
import { EditButtonComponent } from '../component/icons-deprecated/edit-button/edit-button.component';
import { CancelButtonComponent } from '../component/icons-deprecated/cancel-button/cancel-button.component';
import { ExcelButtonComponent } from '../component/icons-deprecated/excel-button/excel-button.component';
import { DownloadButtonComponent } from '../component/icons-deprecated/download-button/download-button.component';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ThreeDotsMenuComponent } from '../component/icons-deprecated/three-dots-menu/three-dots-menu.component';
import { NegativeValueToBracesPipe } from '../../../util/pipes/negative-value-to-braces.pipe';
import { MatExpansionModule } from '@angular/material/expansion';
import { ScrollIntoViewDirective } from '../../../util/directives/scroll-into-view.directive';
import { CheckboxComponent } from '../component/checkbox/checkbox.component';
import { ModalContainerComponent } from '../component/modal-container/modal-container.component';
import { InputComponent } from '../component/input/input-component/input.component';
import { PopupModalComponent } from '../component/popup-modal/popup-modal.component';
import { InputDateComponent } from '../component/input/input-date/input-date.component';
import { SelectorComponent } from '../component/input/selector/selector.component';
import { InputAutocompleteComponent } from '../component/input/input-autocomplete/input-autocomplete.component';
import { TabsComponent } from '../component/tabs/tabs.component';
import { PrefixSuffixPipe } from '../../../util/pipes/prefix-suffix.pipe';
import { VisibilityButtonComponent } from '../component/icons-deprecated/visibility-button/visibility-button.component';
import { DashInsteadOfNullPipe } from '../../../util/pipes/dash-instead-of-null.pipe';
import { SortArrowComponent } from '../component/sort-arrow/sort-arrow.component';
import { DropdownIconComponent } from '../component/icons-deprecated/dropdown-icon/dropdown-icon.component';
import { EyeSvgComponent } from '../component/app-eye-svg/eye-svg.component';
import { ExclamationMarkComponent } from '../component/icons-deprecated/exclamation-mark/exclamation-mark.component';
import { ServcLogoIconComponent } from '../component/icons-deprecated/servc-logo-icon/servc-logo-icon.component';
import { AllArrowsIconComponent } from '../component/icons-deprecated/all-arrows-icon/all-arrows-icon.component';
import { DocumentsIconComponent } from '../component/icons-deprecated/documents-icon/documents-icon.component';
import { SearchIconComponent } from '../component/icons-deprecated/search-icon/search-icon.component';
import { VerticalChartsComponent } from '../component/vertical-charts/vertical-charts.component';
import { VarDirective } from '../../../util/directives/var-directive';
import { TableRowEmptyStateComponent } from '../component/table-row-empty-state/table-row-empty-state.component';
import { TooltipComponent } from '../component/tooltip/tooltip.component';
import { CheckboxSelectorComponent } from '../component/checkbox-selector/checkbox-selector.component';
import { LinkRename } from '../../../util/pipes/link.pipe';
import { ButtonComponent } from '../component/buttons/button.component';
import { BigNumberRounder } from '../../../util/pipes/big-number-rounder.pipe';
import { UploadComponent } from '../component/upload/upload.component';
import { EmptyChartComponent } from '../../empty-state/empty-chart/empty-chart.component';
import { DashIf } from '../../../util/pipes/dash-if.pipe';
import { UpperCaseFirstLetterPipe } from '../../../util/pipes/uppercase-first-letter.pipe';
import { CloseModalComponent } from '../component/close-modal/close-modal.component';
import { ModalThinkTwiceComponent } from '../component/modal-think-twice/modal-think-twice.component';
import { SwitcherComponent } from '../component/switcher/switcher.component';
import { AllIconsComponent } from '../component/all-icons/all-icons.component';
import { EmptyState404Component } from '../../empty-state/empty-state-404/empty-state-404.component';
import { NgxMaskDirective } from 'ngx-mask';
import { LinkShortPipe } from '../../../util/pipes/link-short.pipe';
import {
  SelectorAutocompleteComponent,
} from '../component/input/selector-autocomplete/selector-autocomplete.component';
import { EmptyStateStandardComponent } from '../../empty-state/empty-state-standard/empty-state-standard.component';
import { LastLoginPipe } from '../../../util/pipes/last-login.pipe';
import { ButtonDropDownComponent } from '../component/button-drop-down/button-drop-down.component';
import { ShortenWithoutHoverDirective } from '../../../util/directives/shorten-without-hover.directive';
import { FilterDropdownComponent } from '../component/filter-dropdown/filter-dropdown.component';
import {
  TableHeaderEditStateComponent,
} from '../component/table-header-edit-state/table-header-edit-state.component';
import { DropDownItemComponent } from '../component/drop-down-item/drop-down-item.component';
import { ModalDialogComponent } from '../component/modal-dialog/modal-dialog.component';
import { NumberDashBracesPipe } from 'src/app/util/pipes/number-dash-braces.pipe';
import { TabsWithCounterComponent } from '../component/tabs-with-counter/tabs-with-counter.component';
import { DefaultBulkUploadComponent } from '../../bulk-upload/default-bulk-upload/default-bulk-upload.component';
import { InViewportDirective } from '../../organization/components/fair-value-and-pp-charts/in-viewport-derective';
import { OrcaLogoComponent } from 'src/app/components/orca-logo-svg/orca-logo-svg.component';
import { ModalDeleteListComponent } from '../component/modal-dialog/modal-delete-list/modal-delete-list.component';
import { CircleBadgeCountComponent } from 'src/app/circle-badge/app-circle-badge-count';
import { BadgeComponent } from '../../recovery/component/recovery-market-analysis/ma-tickers/sub/badge/badge.component';
import {
  CardDropdownCheckboxComponent,
} from '../../recovery/component/recovery-market-analysis/ma-tickers/sub/card-dropdown-checkbox/card-dropdown-checkbox.component';
import {
  CardDropdownModalComponent,
} from '../../recovery/component/recovery-market-analysis/ma-tickers/sub/card-dropdown-modal/card-dropdown-modal.component';
import { MaTickersComponent } from '../../recovery/component/recovery-market-analysis/ma-tickers/ma-tickers.component';
import {
  RecoveryTickerChartComponent,
} from '../../recovery/component/recovery-market-analysis/ma-tickers/sub/recovery-ticker-chart/recovery-ticker-chart.component';
import {
  RecoveryTickerModalComponent,
} from '../../recovery/component/recovery-market-analysis/ma-tickers/sub/recovery-ticker-modal/recovery-ticker-modal.component';
import { SortDirective } from '../../../util/directives/sort/sort.directive';
import { EmptyStateCreateComponent } from '../../empty-state/empty-state-create/empty-state-create.component';
import { MathAbsPipe } from 'src/app/util/pipes/math-abs.pipe';
import { DynamicDecimalPipe } from '../../../util/pipes/dynamic-decimal-pipe';
import { OverlayPopUpComponent } from '../component/overlayed-pop-up/overlay-pop-up.component';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { StandardSkeletonTableComponent } from '../../standard-components/skeleton-table/standard-skeleton-table.component';
import { MaSelectorComponent } from '../../../core/component/hornavbar/market-analysis/ma-selector/ma-selector.component';
import { SearchComponent } from 'src/app/domain/shared/component/search/search.component';
import { FormatedInputDateComponent } from "../component/input/formated-date-input/formated-date-input.component";
import { TextWithTooltipComponent } from 'src/app/components/text-with-tooltip/text-with-tooltip.component';
import { FileTypeIconPipe } from '../../../util/pipes/file-icon.pipe';
import { AiStarsSpinnerComponent } from '../component/spinner/ai-stars-spinner/ai-stars-spinner.component';


@NgModule({
  declarations: [
    ModalDialogComponent,
    SpinnerComponent,
    NumberswitcherPipe,
    SwitcherDashBracesPipe,
    // buttons
    DeleteButtonComponent, // ToDo: remove
    CopyButtonComponent, // ToDo: remove
    EditButtonComponent, // ToDo: remove
    CancelButtonComponent, // ToDo: remove
    ExcelButtonComponent, // ToDo: remove
    DownloadButtonComponent, // ToDo Remove
    VisibilityButtonComponent, // ToDo remove
    DropdownIconComponent, // ToDo remove
    EyeSvgComponent, // ToDo remove
    ExclamationMarkComponent, // ToDo remove
    DropdownIconComponent, // ToDo remove
    ServcLogoIconComponent, // ToDo remove
    AllArrowsIconComponent, // ToDo remove
    DocumentsIconComponent, // ToDo remove
    SearchIconComponent, // ToDo remove
    ButtonDropDownComponent, // ask Vanya or Andrey
    ThreeDotsMenuComponent,
    NegativeValueToBracesPipe,
    ScrollIntoViewDirective,
    ModalContainerComponent,
    CheckboxComponent,
    InputComponent,
    BadgeComponent,
    RecoveryTickerModalComponent,
    MaTickersComponent,
    RecoveryTickerChartComponent,
    CardDropdownCheckboxComponent,
    CardDropdownModalComponent,
    PopupModalComponent,
    InputDateComponent,
    FormatedInputDateComponent,
    SelectorComponent,
    InputAutocompleteComponent,
    TabsComponent,
    TabsWithCounterComponent,
    PrefixSuffixPipe,
    MathAbsPipe,
    FilterDropdownComponent, // ToDo Ask Ars, it is only used in the SortArrowComponent.
    DashInsteadOfNullPipe,
    DashIf,
    UpperCaseFirstLetterPipe,
    SortArrowComponent,
    EmptyChartComponent,
    VerticalChartsComponent,
    LinkRename, // think about
    VarDirective,
    CheckboxSelectorComponent,
    TableRowEmptyStateComponent,
    TableHeaderEditStateComponent,
    ButtonComponent,
    BigNumberRounder,
    UploadComponent,
    CloseModalComponent,
    ModalThinkTwiceComponent,
    SwitcherComponent,
    AllIconsComponent,
    EmptyState404Component,
    SelectorAutocompleteComponent,
    EmptyStateStandardComponent,
    EmptyStateCreateComponent,
    DropDownItemComponent,
    LastLoginPipe,
    ShortenWithoutHoverDirective,
    NumberDashBracesPipe,
    DynamicDecimalPipe,
    InViewportDirective,
    OrcaLogoComponent,
    DefaultBulkUploadComponent,
    ModalDeleteListComponent,
    CircleBadgeCountComponent,
    OverlayPopUpComponent,
    StandardSkeletonTableComponent,
    MaSelectorComponent,
    SearchComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    ClipboardModule,
    MatMenuModule,
    DragDropModule,
    NgxMaskDirective,
    LinkShortPipe,
    SortDirective,
    CdkOverlayOrigin,
    CdkConnectedOverlay,
    TooltipComponent,
    TextWithTooltipComponent,
    FileTypeIconPipe,
    AiStarsSpinnerComponent,
  ],
  exports: [
    CommonModule,
    DragDropModule,
    SwitcherDashBracesPipe,
    FormsModule,
    SpinnerComponent,
    ReactiveFormsModule,
    ClipboardModule,
    RouterModule,
    ModalDialogComponent,
    NumberswitcherPipe,
    DeleteButtonComponent,
    CopyButtonComponent,
    EditButtonComponent,
    CancelButtonComponent,
    ExcelButtonComponent,
    MatDatepickerModule,
    ThreeDotsMenuComponent,
    NegativeValueToBracesPipe,
    MatMenuModule,
    MatExpansionModule,
    ModalContainerComponent,
    CheckboxComponent,
    InputComponent,
    BadgeComponent,
    RecoveryTickerModalComponent,
    MaTickersComponent,
    RecoveryTickerChartComponent,
    CardDropdownCheckboxComponent,
    CardDropdownModalComponent,
    InputDateComponent,
    FormatedInputDateComponent,
    PopupModalComponent,
    SelectorComponent,
    InputAutocompleteComponent,
    TabsComponent, // Deprecated, consider using TabsWithCounterComponent
    TabsWithCounterComponent,
    PrefixSuffixPipe,
    MathAbsPipe,
    VisibilityButtonComponent,
    DashInsteadOfNullPipe,
    DashIf,
    UpperCaseFirstLetterPipe,
    SortArrowComponent,
    EmptyChartComponent,
    FilterDropdownComponent,
    DropdownIconComponent,
    ExclamationMarkComponent,
    SearchIconComponent,
    VerticalChartsComponent,
    TooltipComponent,
    ButtonComponent,
    ServcLogoIconComponent,
    EyeSvgComponent,
    EmptyState404Component,
    ScrollIntoViewDirective,
    ShortenWithoutHoverDirective,
    VarDirective,
    CheckboxSelectorComponent,
    ButtonComponent,
    BigNumberRounder,
    UploadComponent,
    AllArrowsIconComponent,
    TableRowEmptyStateComponent,
    DocumentsIconComponent,
    CloseModalComponent,
    ModalThinkTwiceComponent,
    SwitcherComponent,
    ServcLogoIconComponent,
    AllIconsComponent,
    LinkShortPipe,
    DownloadButtonComponent,
    EmptyStateStandardComponent,
    EmptyStateCreateComponent,
    DropDownItemComponent,
    LastLoginPipe,
    ButtonDropDownComponent,
    SelectorAutocompleteComponent,
    TableHeaderEditStateComponent,
    LinkRename,
    NumberDashBracesPipe,
    InViewportDirective,
    OrcaLogoComponent,
    DefaultBulkUploadComponent,
    ModalDeleteListComponent,
    CircleBadgeCountComponent,
    DynamicDecimalPipe,
    SortDirective,
    OverlayPopUpComponent,
    StandardSkeletonTableComponent,
    MaSelectorComponent,
    SearchComponent,
    TextWithTooltipComponent,
    FileTypeIconPipe,
    AiStarsSpinnerComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [DatePipe, DecimalPipe],
})
export class SharedComponentsModule {}
